var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSqlDataSource = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1.5C6.201 1.5 1.5 3.5145 1.5 6V19.5C1.5 21.9855 6.201 24 12 24C17.799 24 22.5 21.9855 22.5 19.5V6C22.5 3.5145 17.799 1.5 12 1.5ZM12 3C17.583 3 21 4.95 21 6C21 7.05 17.583 9 12 9C6.417 9 3 7.05 3 6C3 4.95 6.417 3 12 3ZM3 19.5C3 20.55 6.417 22.5 12 22.5C17.583 22.5 21 20.55 21 19.5V17.3085C18.272 18.8863 15.148 19.647 12 19.5C8.85198 19.647 5.72803 18.8863 3 17.3085V19.5ZM12 18C6.417 18 3 16.05 3 15V12.8085C5.72803 14.3863 8.85198 15.147 12 15C15.148 15.147 18.272 14.3863 21 12.8085V15C21 16.05 17.583 18 12 18ZM3 10.5C3 11.55 6.417 13.5 12 13.5C17.583 13.5 21 11.55 21 10.5V8.3085C18.272 9.88629 15.148 10.647 12 10.5C8.85198 10.647 5.72803 9.88629 3 8.3085V10.5Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSqlDataSource);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/sql-data-source.d0537f3f167962d62a7930c89a752dab.svg";